import React from 'react';
import { Reserved } from './styled';

interface Props {
  className?: String;
}

const DATE = new Date();

export const Copyright: React.FC<Props> = ({className}) => (
  <Reserved className={className}>© {DATE.getFullYear()} Clasificados</Reserved>
);
